import { useNavigate } from "react-router-dom";
import { BrandHeader } from "../../SignUp/BrandSignUp";
import Hero from "./customPricingComponents/Hero";
import PricingPlans from "./customPricingComponents/PricingPlans";
import ComparisonTable from "./customPricingComponents/ComparisonTable";

export default function CustomPricingPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      <BrandHeader
        text={"Login →"}
        onClick={() => {
          navigate("/Brand/Login");
        }}
        visible={false}
        ButtonBorderColor={"none"}
      />
      <Hero />
      <PricingPlans />
      <ComparisonTable />
    </div>
  );
}
